import { jsx as _jsx } from "react/jsx-runtime";
import { CommonLocationPage } from "../../../components/CommonLocationPage";
import { AppSection } from "../../../slices/app/types";
export const SelfEmployedLocationPage = () => {
    return _jsx(CommonLocationPage, { section: AppSection.SelfEmployed });
};
